import React, { useRef } from 'react';
import { selectPeers, useHMSStore } from '@100mslive/react-sdk';
import { Box, Flex } from '@100mslive/roomkit-react';
import { GridCenterView } from '../../gridView';
import PracticeQuestion from './PracticeQuestion';
import PracticeQuestionInfo from './PracticeQuestionInfo';
import { useVoiceAssistant } from '@livekit/components-react';
const PracticeDesktop = React.memo(({ form, handleEndCall, timer, practiceStatus = true, updateSocket }) => {
    const voiceAssistant = useVoiceAssistant();
    console.log(voiceAssistant, 'voiceAssistant');
    const peers = useHMSStore(selectPeers);
    const candidatePeer = peers.filter((peer) => peer.roleName === 'candidate');
    const videoRef = useRef(null);
    return (
        <Box
            css={{
                w: '100%',
                flex: '1 1 0',
                minHeight: 0,
                paddingBottom: 'env(safe-area-inset-bottom)',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
            }}
            id="conferencing"
            data-testid="conferencing"
        >
            <PracticeQuestionInfo form={form} handleEndCall={handleEndCall} timer={timer} />
            <Flex
                css={{
                    width: '100%',
                    overflow: 'hidden',
                    height: '80vh',
                    flexGrow: '1',
                }}
                direction={{ '@initial': 'row', '@md': 'column' }}
                ref={videoRef}
                className="video_question_container"
            >
                <Flex
                    css={{
                        size: '100%',
                        flexDirection: 'column',
                        position: 'relative',
                    }}
                    className="video_container"
                    direction={{
                        '@initial': 'column',
                        '@md': 'column',
                    }}
                >
                    <GridCenterView peers={candidatePeer} maxTileCount={1} practiceStatus={practiceStatus} />
                </Flex>
                <PracticeQuestion
                    agentAudioTrack={voiceAssistant?.audioTrack}
                    practiceStatus={practiceStatus}
                    transcriptDetails={form?.transcriptDetails || ''}
                    updateSocket={updateSocket}
                />
            </Flex>
        </Box>
    );
});

export default PracticeDesktop;
